// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".expand-content[data-v-d10e1f7c]{padding-left:16px}@media(min-width:950px){.expand-content[data-v-d10e1f7c]{padding-left:70px}}.expand-content__title[data-v-d10e1f7c]{width:170px}", ""]);
// Exports
module.exports = exports;
